import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import Newsletter from "./Newsletter";

const Footer = () => (
  <footer className="mt-24 border-t hairline" data-testid="site-footer">
    <div className="section-pad py-16">
      <Newsletter />
    </div>
    <div className="section-pad pb-12 grid gap-8 md:grid-cols-3 border-t hairline pt-12 text-sm">
      <div>
        <div className="font-display text-lg uppercase tracking-tight">Swenkville</div>
      </div>
      <div>
        <ul className="space-y-2">
          <li><Link to="/tees" className="hover:opacity-60" data-testid="footer-link-tees">Tees</Link></li>
          <li><Link to="/headwear" className="hover:opacity-60" data-testid="footer-link-headwear">Headwear</Link></li>
          <li><Link to="/hoodies" className="hover:opacity-60" data-testid="footer-link-hoodies">Hoodies</Link></li>
          <li><Link to="/members" className="hover:opacity-60" data-testid="footer-link-members">Members</Link></li>
        </ul>
      </div>
      <div>
        <ul className="space-y-2">
          <li><a href="mailto:swenkville@gmail.com" className="hover:opacity-60" data-testid="footer-link-contact">Contact</a></li>
          <li><Link to="/admin/login" className="hover:opacity-60" data-testid="footer-link-admin">Admin</Link></li>
        </ul>
      </div>
    </div>
    <div className="section-pad py-6 border-t hairline flex flex-col md:flex-row justify-between gap-3 text-xs text-black/50">
      <span>&copy; {new Date().getFullYear()} Swenkville</span>
      <a href="https://instagram.com" target="_blank" rel="noreferrer" className="hover:opacity-60" data-testid="footer-instagram">
        <Instagram size={14} strokeWidth={1.4} />
      </a>
    </div>
  </footer>
);

export default Footer;
